import React from 'react';
import InformationsLegales from '../components/InformationsLegales';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <InformationsLegales />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
